import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { canManageSchool, useOrgMe } from "@/api/school";
import { useAuth } from "./OidcProvider";

/** 包住「集团管理员或园长」都该进得去的 /admin/* 路由。
 *
 *  和后端 `require_school_manager` / `is_school_manager` 同一口径:
 *  集团管理员 OR 本校园长(school_teachers.role='admin')。
 *
 *  为什么要有这个:侧栏用 adminOrPrincipal 决定谁看得见,而这些路由原先
 *  包的是 AdminRoute(仅管理员)。园长于是**看得见入口、点进去被弹回 `/`**,
 *  而 `/` 是新对话页 —— 表现成"点用户邀请跳回聊天界面"(2026-09-02 生产
 *  用户报)。后端一直是放行园长的,错的只是这层守卫。
 *
 *  ⚠️ orgMe 还在加载时**不能**跳转 —— 那会把园长在数据到达前就弹走,
 *  变成一个随网络快慢时灵时不灵的 bug。加载中先渲染占位。 */
export function ManagerRoute({ children }: { children: ReactNode }): JSX.Element {
  const { state } = useAuth();
  const orgMe = useOrgMe();

  if (state.status !== "authenticated") {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Signing in…
      </div>
    );
  }
  if (state.user.isAdmin) return <>{children}</>;
  if (orgMe.isPending) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        Signing in…
      </div>
    );
  }
  if (canManageSchool(orgMe.data)) return <>{children}</>;
  return <Navigate to="/" replace />;
}
